/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec){
				this.apiSpec = {
					name:'local filter API',
					events:{
						serializeActions: true,
						propagationInfo: {
							namespace: 'localFilters',
							callStack:{
								name: 'getLocalFilters',
								params:[]
							},
							info: {
								supportsUndoRedo: true
							}
						},
						actions: {
							addFilter: {
								eventName:'add',
								isResolvePostResponse: true,
								transactionAPI: this.transaction,
								transactionParamIndex: 2,
								autoCreateTransaction: true,
								getUndoActions: (args, /*returnValue*/ { id }) => {
									//The returnValue of the addFilter api is an object
									//containing the id of the added filter.
									//Remove should only need the id of the filter so enforce it.
									return [{
										name: 'removeFilter',
										params: [{ id: id }]
									}];
								}
							},
							editFilter: {
								eventName:'edit',
								transactionAPI: this.transaction,
								transactionParamIndex: 2,
								autoCreateTransaction: true,
								getUndoActions: (args) => {
									return [{
										name: 'editFilter',
										params: [args[0], this._getCurrentFilterContext(args[0])]
									}];
								}
							},
							removeFilter: {
								eventName:'remove',
								transactionAPI: this.transaction,
								transactionParamIndex: 1,
								autoCreateTransaction: true,
								getUndoActions: (args) => {
									const undoActions = [];
									const itemContext = this._getCurrentItemContext(args[0]);
									if (this.filterExists(itemContext)) {
										const dataSource = this.visualization.getDataSource();
										if (dataSource) {
											undoActions.push({
												callStack:[{
													name:'..'
												}],
												name:'setDataSource',
												params:[dataSource.getId()]
											});
										}

										//The addFilter api requires the itemContext and filter definition which can be obtained from the
										//filter we're removing prior to removing it.
										undoActions.push({
											name: 'addFilter',
											params: [itemContext, this._getCurrentFilterContext(args[0])]
										});
									}
									return undoActions;
								}
							}
						}
					}

				};
			}
			return this.apiSpec;
		}
	}
	return APISpec;
});
